var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgControllerEpisode = function SvgControllerEpisode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 21.002
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "controller_episode_svg__a",
    x: 0,
    y: 0,
    width: 25,
    height: 21.002,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#controller_episode_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "btn_list",
    d: "M3 19a1 1 0 0 1 0-2h10a1 1 0 1 1 0 2Zm13.938-.23v-6.539a.218.218 0 0 1 .322-.2l5.629 3.27a.236.236 0 0 1 0 .4l-5.629 3.27a.2.2 0 0 1-.1.028.226.226 0 0 1-.224-.228ZM3 14a1 1 0 0 1 0-2h10a1 1 0 1 1 0 2Zm0-5a1 1 0 0 1 0-2h19a1 1 0 1 1 0 2Zm0-5a1 1 0 0 1 0-2h19a1 1 0 1 1 0 2Z",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)"
  }))));
};
export { SvgControllerEpisode as ReactComponent };
export default "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"25\" height=\"21.002\" viewBox=\"0 0 25 21.002\">\n  <defs>\n      <filter id=\"btn_list\" x=\"0\" y=\"0\" width=\"25\" height=\"21.002\" filterUnits=\"userSpaceOnUse\">\n          <feOffset input=\"SourceAlpha\"></feOffset>\n          <feGaussianBlur stdDeviation=\"0.5\" result=\"blur\"></feGaussianBlur>\n          <feFlood flood-opacity=\"0.302\"></feFlood>\n          <feComposite operator=\"in\" in2=\"blur\"></feComposite>\n          <feComposite in=\"SourceGraphic\"></feComposite>\n      </filter>\n  </defs>\n  <g transform=\"matrix(1, 0, 0, 1, 0, 0)\" filter=\"url(#btn_list)\">\n      <path id=\"btn_list-2\" data-name=\"btn_list\" d=\"M16682,12079a1,1,0,0,1,0-2h10a1,1,0,1,1,0,2Zm13.938-.23v-6.539a.218.218,0,0,1,.322-.2l5.629,3.27a.236.236,0,0,1,0,.4l-5.629,3.27a.2.2,0,0,1-.1.028A.226.226,0,0,1,16695.936,12078.771ZM16682,12074a1,1,0,0,1,0-2h10a1,1,0,1,1,0,2Zm0-5a1,1,0,0,1,0-2h19a1,1,0,1,1,0,2Zm0-5a1,1,0,0,1,0-2h19a1,1,0,1,1,0,2Z\" transform=\"translate(-16679 -12060)\" fill=\"#fff\" stroke=\"rgba(0,0,0,0)\" stroke-width=\"1\"></path>\n  </g>\n</svg>";